// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './i18n'
import moment from 'moment';        
import axios from 'axios';
import NwImg from 'nw-img-vue';
import VueCardFormat from 'vue-credit-card-validation';

    
require('./assets/css/all.min.css')
require('../node_modules/bootstrap/dist/css/bootstrap.css')
require('./assets/css/style.css')
require('./assets/css/slick-theme.css')
require('./assets/css/slick.css')
require('./assets/css/slick-lightbox.css')
require('../node_modules/simplelightbox/dist/simple-lightbox.min.css')
require('./assets/css/responsive.css')
require('./assets/css/custom-style.css')


require('./assets/js/jquery.js')
require('../node_modules/bootstrap/dist/js/bootstrap.min.js')
require('./assets/js/slick.js')
require('./assets/js/slick-lightbox.js')
require('./assets/js/common.js')

         
Vue.config.productionTip = false
/* Vue.prototype.$hostname = 'http://34.236.249.228/app'; */
Vue.prototype.$hostname = 'https://api.namamedical.org'
Vue.prototype.$vue_hostname = 'https://namamedical.org'
//Vue.prototype.$vue_hostname = 'https://localhost'
//Vue.prototype.$hostname = 'http://127.0.0.1:8000'
Vue.prototype.$i18n_global = i18n;                
Vue.prototype.$moment_global = moment;  
Vue.prototype.$axios_global = axios;     

Vue.mixin({
    methods: {
        isInputValid(input){
            return (typeof input != "undefined" && input!="");
        },
        getError(input){
            return (typeof input != "undefined" && input!="") ? input[0] : '';
        },
    },
})

Vue.use(VueCardFormat);
Vue.use(NwImg);

/* eslint-disable no-new */
const app = new Vue({
    el: '#app',
    store,
    router,
    components: { App },
    i18n,
    template: '<App/>'
})     





// WEBPACK FOOTER //
// ./src/main.js